module.exports = MaterialUI.Checkbox;